import cx from "classix"
import React from "react"

const SeenIcon = ({ seen, className = '' }) => (
    <div className={cx('cw:size-4 ', className, seen ? 'cw:fill-sky-500' : 'cw:fill-neutral-90')}>
        <svg width={15} height={15} viewBox="0 0 24 24">
            <path d="M2.305 11.235a1 1 0 011.414.024l3.206 3.319L14.3 7.289a1 1 0 011.4 1.422l-8.091 8a1 1 0 01-.7.289H6.9a1 1 0 01-.708-.3l-3.911-4.051a1 1 0 01.024-1.414z" />
            {seen && <path d="M20.3 7.289l-7.372 7.289-.263-.273a1 1 0 10-1.438 1.39l.966 1a1 1 0 00.708.3h.011a1 1 0 00.7-.289l8.091-8A1 1 0 0020.3 7.289z" />}
        </svg>

    </div>
)
export default SeenIcon
